import React from 'react';

const StudentDetails = ({ student, handleBackToTable ,showingContainer}) => {
  if (!student) return null;
  return (
    <div className="flex-1 overflow-auto bg-gradient-to-br from-blue-50 via-indigo-50/30 to-purple-50/50 p-2">
      <div className="bg-white/90 backdrop-blur-xl p-8 rounded-2xl shadow-2xl border border-white/20 flex gap-8 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-blue-400/10 to-indigo-500/10 rounded-full -translate-y-16 translate-x-16"></div>
        <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-purple-400/10 to-pink-400/10 rounded-full translate-y-12 -translate-x-12"></div>
{ showingContainer == false &&
        <div className="absolute top-1 left-2 z-20">
          <button onClick={handleBackToTable} className="px-2 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 flex items-center gap-2 font-semibold shadow-lg hover:shadow-xl text-sm">
            <i className="pi pi-arrow-left text-xs"></i> Back
          </button>
        </div>}

        <div className="w-1/5  flex items-start justify-center z-10">
          <div className="w-72 h-52 rounded-2xl bg-gradient-to-br from-indigo-100 to-purple-100 overflow-hidden border-4 border-white shadow-xl flex items-center justify-center relative">
            {student.photoUrl ? (
              <img src={student.photoUrl} alt={student.firstName} className="object-cover w-full h-full" />
            ) : (
              <div className="text-6xl font-bold bg-gradient-to-br from-indigo-500 to-purple-600 bg-clip-text text-transparent">
                {((student.firstName || '')[0]  || '')}
              </div>
            )}
            <div className="absolute bottom-4 right-4 w-8 h-8 bg-green-500 rounded-full border-4 border-white flex items-center justify-center">
              <i className="pi pi-check text-white text-xs"></i>
            </div>
          </div>
        </div>

        <div className="flex-1 z-10">
          <div className="flex items-center justify-between mb-2">
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                {(student.firstName || '') }
              </h3>
            </div>

            <div className="flex items-center gap-4">
              <span className="inline-flex items-center px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm font-medium">
                <i className="pi pi-id-card mr-2"></i>
                {student.admissionNumber || '-'}
              </span>

                <span className="inline-flex items-center px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm font-medium">
                <i className="pi pi-id-card mr-2"></i>
                {student.admissionDate ? new Date(student.admissionDate).toLocaleDateString() : '-'}
              </span>

              <span
                className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${student.status === 'active'
                  ? 'bg-green-100 text-green-800'
                  : student.status === 'inactive'
                    ? 'bg-red-100 text-red-800'
                    : 'bg-yellow-100 text-yellow-800'
                  }`}
              >
                <i className="pi pi-circle-fill mr-2 text-xs"></i>
                {student.status
                  ? student.status.charAt(0).toUpperCase() + student.status.slice(1)
                  : 'Active'}
              </span>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-2 rounded-xl border border-blue-100">
              <div className="flex items-center mb-1">
                <i className="pi pi-graduation-cap text-blue-600 mr-1"></i>
                <p className="text-sm font-semibold text-blue-900">Class & Section</p>
              </div>
              <p className="text-lg font-bold text-gray-900">{student.className ? `${student.className} / ${student.sectionName || '-'}` : '-'}</p>
            </div>

            <div className="bg-gradient-to-r from-orange-50 to-red-50 p-2 rounded-xl border border-orange-100">
              <div className="flex items-center mb-1">
                <i className="pi pi-calendar text-orange-600 mr-1"></i>
                <p className="text-sm font-semibold text-orange-900">Date of Birth</p>
              </div>
              <p className="text-lg font-bold text-gray-900">{student.dateOfBirth ? new Date(student.dateOfBirth).toLocaleDateString() : '-'}</p>
            </div>

            <div className="bg-gradient-to-r from-pink-50 to-rose-50 p-2 rounded-xl border border-pink-100">
              <div className="flex items-center mb-1">
                <i className="pi pi-user text-pink-600 mr-1"></i>
                <p className="text-sm font-semibold text-pink-900">Gender</p>
              </div>
              <p className="text-lg font-bold text-gray-900">{student.gender ? student.gender.charAt(0).toUpperCase() + student.gender.slice(1) : '-'}</p>
            </div>

            <div className="bg-gradient-to-r from-cyan-50 to-teal-50 p-2 rounded-xl border border-cyan-100">
              <div className="flex items-center mb-1">
                <i className="pi pi-heart text-cyan-600 mr-1"></i>
                <p className="text-sm font-semibold text-cyan-900">Blood Group</p>
              </div>
              <p className="text-lg font-bold text-gray-900">{student.bloodGroup || '-'}</p>
            </div>

            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-2  rounded-xl border border-blue-100 md:col-span-1">
              <div className="flex items-center mb-1">
                    <i className="pi pi-id-card text-red-600 mr-1"></i>
                <p className="text-sm font-semibold text-blue-900">Parent Info</p>
              </div>
              <p className="text-sm font-bold text-gray-900">{student.parentName}</p>
              <p className="text-sm font-bold text-gray-900">{student.parentPhone}</p>
              <p className="text-sm text-gray-900">{student.parentEmail}</p>
            </div>
            <div className="bg-gradient-to-r from-pink-50 to-rose-50 p-2 rounded-xl border border-gray-100 md:col-span-1">
              <div className="flex items-center mb-1">
                <i className="pi pi-map-marker text-gray-600 mr-1"></i>
                <p className="text-sm font-semibold text-gray-900">Address</p>
              </div>
              <p className="text-sm font-semibold text-gray-900">{student.parentAddress || '-'}</p>
            </div>
          
          
            <div className="bg-gradient-to-r from-purple-50 to-indigo-50 p-2 rounded-xl border border-purple-100 md:col-span-1">
              <div className="flex items-center mb-1">
                <i className="pi pi-user-plus text-purple-600 mr-1"></i>
                <p className="text-sm font-semibold text-purpule-900">Referred By</p>
              </div>
              <p className="text-lg font-bold text-gray-900">{student.referralName }</p>
            </div>
              </div></div>
      
      </div>
    </div>
  );
};

export default StudentDetails;
